export default "__VITE_ASSET__DnIEEaDd__"